module.exports = __webpack_public_path__ + "img/referto-3.83382bba.webp";